module.exports = __webpack_public_path__ + "static/assets/0dd03e5061d2865c0e8ac50cc75e9982.svg";